<template>
  <div v-if="!loader">
    <b-card class="row-height" no-body>
      <div>
        <b-card no-body class="card-statistics" style="">
          <b-card-body class="statistics-body">
            <b-row class="align-items-center ">
              <b-col gap="3" class="align-items-center flex-row d-flex justify-content-between">
                <h2 class="text-purple font-weight-bold">
                  {{ $t("year_end_tax_statement") }}
                </h2>
              </b-col>
            </b-row>

            <br>
            <br>

            <template>
              <BRow align-content="center" class="justify-content-end">
                <BCol sm="5" v-if="yearOptions.length !== 0" class="d-flex m-0 align-items-center pl-4" style="gap:20px">
                  <BFormGroup
                      label-for="transactionYearSelect"
                      label-align-sm="right"
                      class="mb-0 d-flex align-items-center"
                      style="gap: 15px"
                  >
                    <BFormSelect
                        id="transactionYearSelect"
                        v-model="transactionYear"
                        name="year"
                        :options="transactionYearOptions"
                        class="px-1"
                        style="min-width: 120px;"
                    />
                    <template #label>
                      <h5 class="m-0 select-label" >{{ $t('transaction_report') }} :</h5>
                    </template>
                  </BFormGroup>
                  <BButton @click="downloadTransactionPdfReport" variant="primary" >
                    <FeatherIcon size="12" icon="DownloadIcon" class="mr-1"/>
                    PDF
                  </BButton>
                  <BButton @click="downloadTransactionCsvReport" variant="primary" >
                    <FeatherIcon size="12" icon="DownloadIcon" class="mr-1"/>
                    CSV
                  </BButton>
                </BCol>
              </BRow>
              <hr>
              <BRow class="justify-content-end">
                <BCol sm="5" class="pl-4">
                  <b-form>
                    <b-col v-if="yearOptions.length !== 0" class="d-flex m-0 align-items-center p-0" style="gap:20px">
                      <b-form-group
                          label-for="yearSelect"
                          label-align-sm="right"
                          class="mb-0 d-flex align-items-center"
                          style="gap: 15px"
                      >
                        <template #label>
                          <h5 class="m-0 select-label">{{ $t('tax_statement') }} :</h5>
                        </template>

                        <b-form-select
                            id="yearSelect"
                            v-model="selectedYear"
                            name="year"
                            :options="yearOptions"
                            @change="getYearEndStatement()"
                            class="px-1"
                            style="min-width: 120px;"
                        />
                      </b-form-group>
                      <b-button @click="downloadYearEndPdf()" variant="primary">
                        <FeatherIcon size="12" icon="DownloadIcon" class="mr-1"/>
                        PDF
                      </b-button>
                    </b-col>
                  </b-form>
                </BCol>
              </BRow>

              <div v-if="loaderForTable">
                <img src="/new-loader.svg" />
              </div>
              <div v-else>
                <div v-if="yearOptions.length === 0" class="mt-5 text-center">
                  <feather-icon icon="InfoIcon" size="50" class="text-muted mb-2"/>
                  <h4 class="text-muted">{{ $t('no_year_end_statements_available') }}</h4>
                  <p class="text-muted small">
                    {{ $t('statements_are_generated_for_completed_calendar_years') }}
                  </p>
                </div>
                <div v-else-if="yearEndData" class="mt-3">
                  <p class="medium mb-1"></p>
                  <h3 class="mt-2 mb-0 text-purple font-weight-bold">{{ $t('saldo_balance') }}</h3>
                  <p>({{ $t('as_of') }} 31.12.{{ selectedYear }})</p>
                  <table class="styled-table">
                    <thead>
                    <tr>
                      <th>{{ $t('currency') }}</th>
                      <th v-for="currency in yearEndCurrencies" :key="'cash-' + currency">
                        {{ currency.toUpperCase() }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">{{ $t('saldo_balance') }}</th>
                      <td v-for="currency in yearEndCurrencies" :key="'cash-balance-' + currency">
                        {{
                          yearEndData.cash_balances &&
                          yearEndData.cash_balances[currency] !== undefined &&
                          yearEndData.cash_balances[currency] !== null
                              ? amountFormat(yearEndData.cash_balances[currency], currency) : '-'
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <h3 class="mt-3 mb-0 text-purple font-weight-bold">{{ $t('open_receivables') }} </h3>
                  <p>({{ $t('as_of') }} 31.12.{{ selectedYear }})</p>
                  <b-table
                      :items="yearEndData.open_invoices"
                      :fields="yearEndOpenInvoiceFields"
                      small
                      bordered
                      responsive
                      class="styled-table"
                  >
                    <template #cell(invoice_id)="data">
                      {{ 'I-' + data.item.invoice_id }}
                    </template>
                    <template #cell(invested_amount)="data">
                      {{ amountFormat(data.item.invested_amount, data.item.currency) }}
                    </template>
                  </b-table>

                  <h3 class="mt-3 mb-0 text-purple font-weight-bold">{{ $t('total_assets') }}</h3>
                  <p class="medium mb-1">{{ $t('total_assets') }} = {{ $t('saldo_balance') }} + {{ $t('open_receivables') }} ({{ $t('as_of') }} 31.12.{{ selectedYear }})</p>
                  <table class="styled-table">
                    <thead>
                    <tr>
                      <th>{{ $t('currency') }}</th>
                      <th v-for="currency in flatCurrencies" :key="'assets-' + currency">
                        {{ currency.toUpperCase() }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">{{ $t('saldo_balance') }}</th>
                      <td v-for="currency in flatCurrencies" class="col-2" :key="'assets-cash-' + currency">
                        {{
                          yearEndData.total_assets &&
                          yearEndData.total_assets.per_currency &&
                          yearEndData.total_assets.per_currency[currency]
                              ? amountFormat(yearEndData.total_assets.per_currency[currency].cash || 0, currency) : '-'
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t('open_receivables') }}</th>
                      <td v-for="currency in flatCurrencies" :key="'assets-open-' + currency">
                        {{
                          yearEndData.total_assets &&
                          yearEndData.total_assets.per_currency &&
                          yearEndData.total_assets.per_currency[currency]
                              ? amountFormat(yearEndData.total_assets.per_currency[currency].open_principal || 0, currency) : '-'
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t('total_assets') }}</th>
                      <td v-for="currency in flatCurrencies" :key="'assets-total-' + currency">
                        {{
                          yearEndData.total_assets &&
                          yearEndData.total_assets.per_currency &&
                          yearEndData.total_assets.per_currency[currency]
                              ? amountFormat(yearEndData.total_assets.per_currency[currency].total_assets || 0, currency) : '-'
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <h3 class="mt-3 mb-0 text-purple font-weight-bold">{{ $t('realised_gains') }}</h3>
                  <p class="medium mb-1">{{ $t('as_of') }} 01.01.{{ selectedYear }} – 31.12.{{ selectedYear }}</p>
                  <table class="styled-table">
                    <thead>
                    <tr>
                      <th>{{ $t('currency') }}</th>
                      <th v-for="currency in flatCurrencies" :key="'gains-' + currency">
                        {{ currency.toUpperCase() }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">{{ $t('total_realised') }}</th>
                      <td v-for="currency in flatCurrencies" class="col-2" :key="'gains-net-' + currency">
                        {{
                          yearEndData.realised_gains &&
                          yearEndData.realised_gains.per_currency &&
                          yearEndData.realised_gains.per_currency[currency]
                              ? amountFormat(yearEndData.realised_gains.per_currency[currency].total_net_return || 0, currency) : '-'
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t('settled_invoice_assets') }}</th>
                      <td v-for="currency in flatCurrencies" :key="'gains-count-' + currency">
                        {{
                          yearEndData.realised_gains &&
                          yearEndData.realised_gains.per_currency &&
                          yearEndData.realised_gains.per_currency[currency]
                              ? (yearEndData.realised_gains.per_currency[currency].settled_deals_count || 0) : '-'
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <h3 class="mt-3 mb-0 text-purple font-weight-bold">{{ $t('realised_loss') }}</h3>
                  <p class="medium mb-1">{{ $t('as_of') }} 01.01.{{ selectedYear }} – 31.12.{{ selectedYear }}</p>
                  <b-table
                      :items="yearEndData.realised_loss || []"
                      :fields="yearEndRealisedLossFields"
                      responsive
                      small
                      bordered
                      class="styled-table"
                  >
                    <template #cell(invoice_id)="data">
                      {{ 'I-' + data.item.invoice_id }}
                    </template>
                    <template #cell(invested_amount)="data">
                      {{ amountFormat(data.item.invested_amount, data.item.currency) }}
                    </template>
                  </b-table>
                </div>
              </div>
            </template>

          </b-card-body>
        </b-card>
      </div>
    </b-card>
  </div>
  <div v-else>
    <img src="/new-loader.svg"/>
  </div>
</template>
<script>
import fileDownload from "js-file-download";
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat';

export default {
  data() {
    return {
      selectedYear: null,
      transactionYear: 'Full',
      yearEndData: null,
      company: null,
      loader: false,
      loaderForTable: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {

    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },
    getData() {
      this.loader = true;
      this.$http
          .post(`/company/show/${this.$store.state.auth.user.company_id}`)
          .then((res) => {
            if (res) {
              this.company = res.data.value;
              this.loader = false;
              this.initSelectedYear();
            }
          });
    },
    initSelectedYear() {
      if (this.yearOptions.length > 0) {
        this.selectedYear = this.yearOptions[this.yearOptions.length - 1].value;
        this.getYearEndStatement();
      }
    },
    getYearEndStatement() {
      if (!this.selectedYear) return;
      this.loaderForTable = true;
      this.$http.get(`/buyer/year-end-statement`, {params: {year: this.selectedYear}})
          .then(res => {
            this.yearEndData = res.data.value || res.data;
          })
          .finally(() => {
            this.loaderForTable = false;
          });
    },
    downloadYearEndPdf() {
      const year = this.selectedYear;
      this.$http.post(`/buyer/year-end-statement/pdf`, {year: this.selectedYear}, {responseType: 'blob'})
          .then(response => {
            fileDownload(response.data, `year-end-statement-${year}.pdf`);
          });
    },
    downloadTransactionPdfReport() {
      const url = '/transactions/export/pdf';
      const payload = {company_id: this.$store.state.auth.user.company_id, year: this.transactionYear}
      this.$http.post(url, payload, {responseType: 'blob'}).then((response) => {
        fileDownload(response.data, this.$t('transaction_report_pdf'));
      });
    },
    downloadTransactionCsvReport() {
      const url = '/transactions/export/csv';
      const payload = {company_id: this.$store.state.auth.user.company_id, year: this.transactionYear}
      this.$http.post(url, payload, {responseType: 'blob'}).then((response) => {
        const filename = this.$t('transaction_report_csv');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(response.data, filename);
        } else {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(response.data);
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  },
  computed: {
    transactionYearOptions() {
      return [
        {
          value: 'Full',
          text: this.$t('full'),
          label: this.$t('full'),
        },
        ...this.yearOptions,
      ]
    },
    yearOptions() {
      if (!this.company?.created_at) return []
      const startYear = new Date(this.company.created_at).getFullYear()
      const lastYear = new Date().getFullYear() - 1 // Tax statements are for completed years
      const years = []
      if (startYear > lastYear) return [];
      for (let year = startYear; year <= lastYear; year++) {
        years.push({
          value: year,
          text: year.toString(),
        })
      }
      return years
    },
    yearEndCurrencies() {
      if (!this.yearEndData) return []
      const currencySet = new Set()

      if (this.yearEndData.cash_balances) {
        Object.keys(this.yearEndData.cash_balances).forEach(c => currencySet.add(c))
      }
      if (this.yearEndData.total_assets?.per_currency) {
        Object.keys(this.yearEndData.total_assets.per_currency).forEach(c => currencySet.add(c))
      }
      if (this.yearEndData.realised_gains?.per_currency) {
        Object.keys(this.yearEndData.realised_gains.per_currency).forEach(c => currencySet.add(c))
      }

      return Array.from(currencySet)
    },
    flatCurrencies() {
      if (!this.yearEndData) return []
      return Object.keys(this.yearEndData.cash_balances).filter((c) => {
        return ['EUR', 'USD', 'GBP', 'CHF'].includes(c)
      })
    },
    yearEndOpenInvoiceFields() {
      return [
        {key: 'invoice_id', label: this.$t('invoice_id')},
        {key: 'investment_date', label: this.$t('investment_date')},
        {key: 'status_as_of_31_12', label: this.$t('status_as') + ' 31.12.' + this.selectedYear},
        {key: 'invested_amount', label: this.$t('investment_amount')},
        {key: 'currency', label: this.$t('currency')},
        {key: 'due_date', label: this.$t('due_date')},
        {key: 'reference', label: this.$t('reference')},
      ]
    },
    yearEndRealisedLossFields() {
      return [
        {key: 'invoice_id', label: this.$t('invoice_id')},
        {key: 'currency', label: this.$t('currency')},
        {key: 'invested_amount', label: this.$t('investment_amount')},
      ]
    }
  },
};
</script>
<style scoped>
.styled-table {
  margin-top: 50px;
  border-collapse: collapse;
  font-size: 16px;
  width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.styled-table thead tr {
  background-color: #798581;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  border: 1px solid #dee2e6;
  text-align: center;
}

.styled-table tbody tr:nth-child(even) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:hover {
  background-color: #e9ecef;
}

.status-cell {
  width: fit-content !important;
  min-width: fit-content !important;
  white-space: nowrap;
}

::v-deep .custom-control.custom-switch label.custom-control-label::after {
  top: calc(0.225rem + 2px);
}

.styled-table {
  margin-top: 0;
}
.select-label{
  min-width: 165px;
  text-align: left;
}
</style>
